<template>
    <div class="analytics">
        <div class="groupField_wrap">
            <field
                margin="0 10px 0 0"
                width="300px"
                label="Customer"
                placeholder="Select customer"
                @updateAutocomplete="onAutocomplete($event, 'customer_id')"
                :autocompleteValue="customer_id"
                :items="customers"
                :isClearable="false"
                is-autocomplete
                is-disabled
            ></field>
            <field
                margin="0 10px 0 0"
                width="140px"
                label="WO type"
                placeholder="Select WO type"
                @updateSelect="onAutocomplete($event, 'type')"
                :autocompleteValue="type"
                :items="workOrderType"
                :isClearable="false"
                is-select
            ></field>
            <field
                margin="0 10px 0 0"
                width="150px"
                label="Unit type"
                placeholder="Select unit type"
                @updateSelect="onAutocomplete($event, 'unit_type_id')"
                :autocompleteValue="unit_type_id"
                :items="workOrderUnitType"
                :isClearable="false"
                is-select
                is-disabled
            ></field>
            <field
                margin="0 10px 0 0"
                width="150px"
                type="text"
                label="Start date"
                placeholder="Enter date"
                :dateValue="date"
                @updateDate="onDate($event, 'date')"
                :dateAllowed="{ onlyMonday: true }"
                is-no-title
                is-date
            ></field>
            <field
                margin="0 10px 0 0"
                width="150px"
                type="number"
                label="Plan rate lvl 1"
                placeholder="0"
                :setInputValue="rate_1"
                icon="percent"
                @updateInput="onInput($event, 'rate_1')"
            ></field>
            <field
                margin="0 10px 0 0"
                width="150px"
                type="number"
                label="Plan rate lvl 2"
                placeholder="0"
                :setInputValue="rate_2"
                icon="percent"
                @updateInput="onInput($event, 'rate_2')"
            ></field>
            <field
                margin="0 10px 0 0"
                width="150px"
                type="number"
                label="Plan rate lvl 3"
                placeholder="0"
                :setInputValue="rate_3"
                icon="percent"
                @updateInput="onInput($event, 'rate_3')"
            ></field>
            <div class="analytics_apply">
                <button @click="onApply" class="analytics_apply-btn">Apply</button>
            </div>
        </div>
        <statistics-chart
            v-if="statistics && statistics.length"
            :statistics="statistics"
            @updateStatisticsData="onStatisticsData"
        ></statistics-chart>
        <div class="chartWrapper groupField_wrap">
            <line-chart
                v-if="chartData"
                :chartData="chartData"
                :chartOptions="getChartOptions"
            ></line-chart>
        </div>
        <statistics-info
            v-if="isStatisticsInfo"
            :currentDataInfo="currentDataInfo"
            @updateClose="isStatisticsInfo = false"
        ></statistics-info>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import LineChart from "@/components/Fleet/WorkOrdersStatistics/LineChart/LineChart";
import StatisticsInfo from "@/components/Fleet/WorkOrdersStatistics/Analytics/StatisticsInfo/StatisticsInfo";
import StatisticsChart from "@/components/Fleet/WorkOrdersStatistics/StatisticsChart/StatisticsChart";
// helper
import { positiveNumber, splitArray } from "@/helper";
// constants
import { chartConfig, chartOptions } from "@/components/Fleet/WorkOrdersStatistics/LineChart/chartLineConfig";

export default {
	name: "Analytics",
	components: {
		LineChart,
		StatisticsChart,
		StatisticsInfo
	},
	computed: {
		...mapGetters([ 'statisticsData' ]),
		getChartOptions() {
			return chartOptions;
		}
	},
	data: () => ({
		chartData: null,
		customers: [],
		statistics: [],
		workOrderUnitType: [],
		workOrderType: [],
		customer_id: 328,
		unit_type_id: 1,
		type: 2,
		date: null,
		rate_1: 0,
		rate_2: 0,
		rate_3: 0,
		isStatisticsInfo: false,
		currentDataInfo: null
	}),
	methods: {
		...mapActions([ 'onWorkOrdersStatistics', 'onWorkOrdersStatisticsEdit', 'onWorkOrdersStatisticsInfo' ]),
		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},
		onDate(value, key) {
			this[key] = value;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onStatisticsData(date) {
			const {
				customer_id,
				unit_type_id,
				type
			} = this.$data;

			const values = {
				filter_customer_id: customer_id,
				filter_orderType: type,
				filter_type: unit_type_id,
			};
			await this.onWorkOrdersStatisticsInfo({ date, values });
			this.currentDataInfo = {
				currentDate: date,
				...values
			};
			this.isStatisticsInfo = true;
		},
		onSetDataStatistics(values) {
			if (values) {
				const {
					customers,
					date,
					workOrderUnitType,
					workOrderType,
					plan_rate,
					statistics
				} = values;

				this.chartData = chartConfig(statistics);

				this.customers = customers;
				this.statistics = splitArray(statistics, 7);
				this.date = date;
				this.workOrderUnitType = workOrderUnitType;
				this.workOrderType = workOrderType;

				for (const planRateKey in plan_rate) {
					this['rate_' + planRateKey] = plan_rate[planRateKey]; 
				}
			}
		},
		async onApply() {
			const {
				customer_id,
				unit_type_id,
				type,
				date,
				rate_1,
				rate_2,
				rate_3
			} = this.$data;

			const values = {
				filter_customer_id: customer_id,
				filter_date: date,
				filter_orderType: type,
				filter_type: unit_type_id,
				rate_1: positiveNumber(rate_1),
				rate_2: positiveNumber(rate_2),
				rate_3: positiveNumber(rate_3),
			};

			await this.onWorkOrdersStatisticsEdit(values);
			this.onSetDataStatistics(this.statisticsData);
		}
	},
	async mounted() {
		await this.onWorkOrdersStatistics();
		this.onSetDataStatistics(this.statisticsData);
	}
};
</script>

<style lang="scss">
@import "analyticsAll";
</style>
<style scoped lang="scss">
@import "analytics";
</style>
